// extracted by mini-css-extract-plugin
export default {"content":"Solvency_content__bALKZ"};